module.exports = __webpack_public_path__ + "img/男.2c615bcb.png";